import { axios } from "@/lib/axios";
import { AxiosResponse } from "axios";

export const apiGetSubscriptionPlan = (): Promise<AxiosResponse<any, any>> => {
  return axios.get("/payment-s/api/v1/payments-plans-subscriptions");
};

export const apiGetSonsoringPlan = (): Promise<AxiosResponse<any, any>> => {
  return axios.get("/payment-s/api/v1/sponsoring-plans-subscriptions");
};

export const apiActivateAccount = (
  data: any
): Promise<AxiosResponse<any, any>> => {
  return axios.post("/payment-s/api/v1/purchases", data);
};
export const apiActivateAccountPaypal = (
  data: any
): Promise<AxiosResponse<any, any>> => {
  return axios.post("/payment-s/api/v1/purchases", data);
};

// Carte intégrée PayPal (Card Fields) : récupère le client token pour initialiser le SDK.
export const apiGetPaypalClientToken = (): Promise<
  AxiosResponse<any, any>
> => {
  return axios.get("/payment-s/api/v1/purchases/paypal-client-token");
};

// Capture l'ordre PayPal (carte) après saisie réussie côté front.
export const apiCapturePurchasePaypal = (
  orderId: string
): Promise<AxiosResponse<any, any>> => {
  return axios.post(
    "/payment-s/api/v1/purchases/" + orderId + "/paypal-capture"
  );
};

export const apiDesactivateAccount = (
  data: string,
  dataTosend: any
): Promise<AxiosResponse<any, any>> => {
  return axios.patch(
    "/payment-s/api/v1/purchases/" + data + "/cancel-purchase",
    dataTosend
  );
};

export const apiGetPurchaseInfo = (
  data: string
): Promise<AxiosResponse<any, any>> => {
  return axios.get("/payment-s/api/v1/purchases/" + data);
};

export const apiDeleteAccount = (
  data: any
): Promise<AxiosResponse<any, any>> => {
  return axios.post("/auth-s/api/v1/auth/delete/by-member", data);
};
